import type { Config } from "tailwindcss";
import tailwindcssReactAriaComponents from "tailwindcss-react-aria-components";

const pxToRem = (px: number) => `${px / 16}rem`;

const baseTailwindConfig: Config = {
  content: [
    "./src/pages/**/*.{js,ts,jsx,tsx,mdx}",
    "./src/components/**/*.{js,ts,jsx,tsx,mdx}",
    "./src/app/**/*.{js,ts,jsx,tsx,mdx}",
    "./src/styles/font/index.ts",
  ],
  theme: {
    colors: {
      inherit: "inherit",
      transparent: "transparent",
      current: "currentColor",
      "lossdog-neutral-50": "#F7F7F7",
      "lossdog-neutral-300": "#909090",
      "lossdog-success-400": "#26B12F",
      "lossdog-danger-200": "#E30158",
    },
    borderRadius: {
      none: "0rem",
    },
    maxWidth: {
      none: "none",
      modal: pxToRem(720),
      toast: pxToRem(720),
    },
    spacing: {
      "0": "0rem",
    },
    backdropBlur: {},
    blur: {},
    boxShadow: {},
    rotate: {
      "0": "0deg",
      "45": "45deg",
      "90": "90deg",
      "180": "180deg",
      "270": "270deg",
      "360": "360deg",
    },
    screens: {
      // why are breakpoints in rems? read this: https://www.joshwcomeau.com/css/surprising-truth-about-pixels-and-accessibility/
      dm: pxToRem(360),
      t: pxToRem(600),
      m: pxToRem(1024),
      dd: pxToRem(1280),
      dl: pxToRem(1680),
    },
    keyframes: {
      "drawer-slide-right": {
        from: {
          transform: "translateX(100%)",
        },
        to: {
          transform: "translateX(0)",
        },
      },
      "drawer-slide-left": {
        from: {
          transform: "translateX(-100%)",
        },
        to: {
          transform: "translateX(0)",
        },
      },
      "loader-spin": {
        to: {
          transform: "rotate(360deg)",
        },
      },
      "modal-bounce-in": {
        "0%": { transform: "scale(0.95)", opacity: "0" },
        "50%": { transform: "scale(1.02)" },
        "100%": { transform: "scale(1)", opacity: "1" },
      },
      "modal-bounce-out": {
        "0%": { transform: "scale(1)", opacity: "1" },
        "100%": { transform: "scale(0.95)", opacity: "0" },
      },
      "salary-flash-up": {
        "0%": { color: "theme(colors.interactive-primary-hover)" },
        "50%": { color: "oklch(from theme(colors.info-success) 0.83 0.18 h)" },
        "100%": { color: "theme(colors.info-success)" },
      },
      "salary-flash-down": {
        "0%": { color: "theme(colors.interactive-primary-hover)" },
        "50%": { color: "oklch(from theme(colors.info-error-2) 0.98 0.3 h)" },
        "100%": { color: "theme(colors.info-error-2)" },
      },
    },
    animation: {
      "drawer-enter-right": "drawer-slide-right 0.3s",
      "drawer-exit-right": "drawer-slide-right 0.3s reverse",
      "drawer-enter-left": "drawer-slide-left 0.3s",
      "drawer-exit-left": "drawer-slide-left 0.3s reverse",
      "loader-spin": "loader-spin 1s linear infinite",
      "overlay-bounce-in": "modal-bounce-in 0.3s ease-out",
      "overlay-bounce-out": "modal-bounce-out 0.2s ease-in",
      "salary-flash-up": "salary-flash-up 1s ease-in-out",
      "salary-flash-down": "salary-flash-down 1s ease-in-out",
    },
    fontSize: {
      inherit: "inherit",
    },
    fontFamily: {},
    fontWeight: {},
    extend: {
      flex: {
        fill: "1 0 0",
      },
    },
  },
  plugins: [tailwindcssReactAriaComponents],
};

export default baseTailwindConfig;
